import { render, staticRenderFns } from "./PartnerIframe.vue?vue&type=template&id=593826c6&"
import script from "./PartnerIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports